import { Product } from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export type ProductFormActionsContextType = {
  onAfterAddProduct?: (
    createdProduct: Product,
    // depending on how nested the form is, we may need to pass in the navigation to access correct
    // navigation context
    navigation: any
  ) => Promise<void> | void;
};

export const ProductFormActionsContext = React.createContext<
  ProductFormActionsContextType | undefined
>(undefined);
